// @react-pdf's image fetching wraps ArrayBuffers in Node's `Buffer`, which Vite
// doesn't polyfill, so `<Image>` throws "Buffer is not defined" without this.
import { Buffer } from 'buffer';

if (typeof (globalThis as { Buffer?: unknown }).Buffer === 'undefined') {
    (globalThis as { Buffer: typeof Buffer }).Buffer = Buffer;
}
